import React, { memo, useMemo } from 'react';
import { withStyles } from '@material-ui/core/styles';
import appConstants from '@appConstants';

interface RouteLockState {
  value: number;
  text: string;
  icon: string;
  toolTipInfo: string;
}

const findLockStateByValue = (value: number): RouteLockState | undefined =>
  Object.values(appConstants.routeLockStates).find(
    (routeLockState: any) => routeLockState.value === value
  ) as RouteLockState | undefined;

const styles = (theme: any) => ({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  icon: {
    fontSize: '16px',
    color: theme.iconColor
  },
  iconLock: {
    color: theme.HeaderSelectedText
  }
});

interface ReadOnlyLockStatusRendererProps {
  classes: Record<string, string>;
  value: number;
  data: {
    routeName?: string;
    [key: string]: any;
  };
}

const ReadOnlyLockStatusRenderer: React.FC<ReadOnlyLockStatusRendererProps> = ({ classes, value, data }) => {
  const lockState = useMemo(() => findLockStateByValue(value), [value]);

  const iconClasses = useMemo(() => {
    if (!lockState) return classes.icon;
    let className = `${lockState.icon} ${classes.icon}`;
    if (lockState.text !== 'Unlock') {
      className += ` ${classes.iconLock}`;
    }
    return className;
  }, [lockState, classes.icon, classes.iconLock]);

  if ((data && data.routeName === appConstants.UNRTD_ROUTENAME) || !lockState) {
    return null;
  }

  return (
    <div className={classes.root}>
      <i className={iconClasses} />
    </div>
  );
};

export default withStyles(styles)(memo(ReadOnlyLockStatusRenderer));
